import { format } from 'date-fns';
import language from '../lang/language';
export function isDefinedNotNull(variable) {
    return typeof variable !== 'undefined' && variable !== null;
}
export function isDefinedNotNullNotEmpty(variable) {
    return (typeof variable !== 'undefined' &&
        variable !== null &&
        variable.trim() != '');
}
export function formatMoney(value, thousandSeparator = ',') {
    return value.toLocaleString('en').replace(/,/g, thousandSeparator);
}
export function range(start = 1, end = 1, step = 1) {
    let rangeValues = [];
    for (let i = start; i <= end; i += step) {
        rangeValues.push(i);
    }
    return rangeValues;
}
export function getTime(date) {
    return format(new Date(date), 'hh:mm');
}
export function formatDate(date, formatString) {
    return format(new Date(date), formatString);
}
export function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}
export function getType(type) {
    if (type == 0) {
        return 'Accommodation';
    }
    else if (type == 1) {
        return 'Activities';
    }
    else if (type == 2) {
        return 'Epicurean';
    }
    else if (type == 3) {
        return 'Shopping';
    }
}
export function getPriceAvailabilityText(type) {
    if (type == 0) {
        return language.check_price_availability_acc;
    }
    else if (type == 1) {
        return language.check_price_availability_act;
    }
    else if (type == 2) {
        return language.check_price_availability_res;
    }
    else if (type == 3) {
        return language.check_price_availability_shp;
    }
}
export function getAvailableProductText(type) {
    if (type == 1) {
        return language.available_products_act;
    }
    else if (type == 3) {
        return language.available_products_shp;
    }
    else {
        return language.available_products;
    }
}
export function getBookNow(type) {
    if (type == 3) {
        return language.add_to_wishlist_shp;
    }
    else {
        return language.add_to_wishlist;
    }
}
export function getNotAvailable(type) {
    if (type == 3) {
        return language.not_available_shp;
    }
    else {
        return language.not_available;
    }
}
